import axios from 'axios';

// Relative by default, which is right in both places it runs: the dev server
// proxies /api to the backend (see vite.config.js), and in production the site
// is served from the same origin as the API. An absolute URL here would need a
// CORS header in production purely to support development.
//
// VITE_API_URL overrides it for a deployment where the two are split.
const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authService = {
  sendOtp: (email) => api.post('/auth/send-otp', { email }),
  register: (data) => api.post('/auth/register', data),
  login: (username, password) => api.post('/auth/login', { username, password }),
  getStats: () => api.get('/auth/profile/stats'),
};

export default api;
